
export default class RemoveOperation {
  constructor (parts) {
    this.removedParts = parts;
  }

  opType () {
    return 'remove';
  }

  getRootParts (root) {
    return this.removedParts
  }

}



// WEBPACK FOOTER //
// ./src/assets/javascripts/nesting/operations/remove_operation.js